import { CreateUser, CreateUserAssignment } from './create-user.model';

export interface UserForm {
  address: string;
  avs: string;
  canton: string;
  classe: string;
  dateOfBirth: string;
  defaultDial: string;
  email: string;
  f2aCondition: string;
  firstName: string;
  gender: string;
  grpEtablissement: string;
  lastName: string;
  locality: string;
  officialFirstName: string;
  officialLastName: string;
  password: string;
  phone: string;
  preferredLanguage: UserFormPreferredLanguage;
  roles: string[];
  title: string;
  zip: string;
}

export interface UserFormPreferredLanguage {
  id: number;
  name: string;
  acronym: string;
  lang: string;
}

export function toCreateUserModel(input: UserForm): CreateUser {
  return {
    firstName: input.firstName,
    lastName: input.lastName,
    email: input.email,
    locality: input.locality !== '' ? input.locality : null,
    password: input.password,
    title: input.title,
    preferredLanguage: input.preferredLanguage.acronym,
    extension: {
      activationCode: input.password,
      address: input.address !== '' ? input.address : null,
      avs: input.avs,
      canton: input.canton !== '' ? input.canton : null,
      class: input.classe,
      dateOfBirth: input.dateOfBirth,
      establishmentNames: [input.grpEtablissement],
      gender: input.gender,
      officialFirstName: input.officialFirstName,
      officialLastName: input.officialLastName,
      orgNames: [],
      phone: input.phone !== '' ? input.defaultDial + input.phone : '',
      twoFactorAuthType: input.f2aCondition,
      zip: input.zip !== '' ? input.zip : null,
    },
    orgAssignments: input.roles
      .map(r => {
        if (r !== '') {
          return { name: r } as CreateUserAssignment;
        }
      })
      .filter(r => r),
  };
}
